import type { FaireProductEntity } from "../../entity_types/product";

export const p_c1bsqrndto: FaireProductEntity = {
  token: "p_c1bsqrndto",
  type: "product",
  name: "Moroccan Kilim Slippers",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl: "https://cdn.faire.com/fastly/302002ed3df114150a850b6349df3c735fba2267a74351f6a8e6198e6ce5ae28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe78138ffc778943dee80083d26469460c0f4430d2e60f5bf0ea69591173f79f.jpeg",
    "https://cdn.faire.com/fastly/da687e55259c21b525c7f07fc22b2d5db95e9265483ce1d1e1be62b03646f03a.jpeg",
    "https://cdn.faire.com/fastly/4776e244538537c87f6644e1d4861d1b60f30dd1c797e6f6ee7524869dedf0b9.jpeg",
    "https://cdn.faire.com/fastly/453062b14fab15ee9bbecc05a80382e0aa93ca0b35a43c92d26f8cfb2aef6322.jpeg",
    "https://cdn.faire.com/fastly/50bfa156fa14b7101e2d4e8870406c498bcd6266737e61b2334422c352ef6a49.jpeg"
  ],
  priceDollars: 25,
  description: "Our Moroccan Kilim Slippers are produced in the pointed Arab style that took Parisian fashion houses by storm in the 17th century.\n\nMoroccan textile Kilim rugs are among the most vivid in all the world. The wool is dyed with natural dyes, resulting in extremely varied designs and colors. Our slippers are made of these vintage rugs, so each pair has a deep sense of history. The insoles are made with strong but soft goat leather to provide the perfect balance between comfort and durability. These slippers will only get better with time, as they mold to the shape of your foot.\n\nLike snowflakes or fingerprints, no two pairs of our Kilim House Slippers are alike. Each pair will be varied in color and pattern.\n\n• Indoor use only.\n• Spot clean with damp cloth.\n\nSizes:\n\n• Women's Small: US(5.5-6.5)\n• Women's Medium: US(7-8)\n• Women's Large: US(8.5-9.5)\n\n***Please note: Sizes may vary due to hand-made nature of artisan work.",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:43:24.942Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
